import { deliveryVariants, imageSrcSet } from "./image-delivery";
import type { FocalPoint } from "./media-taxonomy";
import { HERO_DESKTOP_MEDIA, HERO_MOBILE_MEDIA } from "./home-hero-delivery";

interface HeroPhoto { mediaUrl?: string | null; mediaVariants?: unknown; mediaFocal?: FocalPoint | null }
interface HeroFallback { src: string; srcSet?: string | undefined; variants?: unknown; mobileSrc?: string | undefined }
export interface HeroDelivery { src: string; srcSet: string | undefined; mobileSrc: string | undefined; focal?: FocalPoint | undefined }
interface HeroPreloadLink {
  rel: string;
  as: string;
  href: string;
  fetchpriority: string;
  media?: string;
  imageSrcSet?: string;
  imageSizes?: string;
}

/** Resolve the exact same photo for the head and rendered hero, preserving CMS selection. */
export function heroDelivery(photo: HeroPhoto | null | undefined, fallback: HeroFallback): HeroDelivery {
  if (photo?.mediaUrl) {
    return { src: photo.mediaUrl, srcSet: imageSrcSet(deliveryVariants(photo.mediaUrl, photo.mediaVariants)), mobileSrc: undefined, focal: photo.mediaFocal ?? undefined };
  }
  const variants = deliveryVariants(fallback.src, fallback.variants);
  return {
    src: variants.at(-1)?.url ?? fallback.src,
    srcSet: imageSrcSet(variants) ?? fallback.srcSet,
    mobileSrc: fallback.mobileSrc,
  };
}

export function heroPreloadLinks(photo: HeroDelivery): HeroPreloadLink[] {
  if (!photo.src) return [];
  const image = {
    rel: "preload", as: "image", href: photo.src, fetchpriority: "high",
    ...(photo.srcSet ? { imageSrcSet: photo.srcSet, imageSizes: "100vw" } : {}),
  };
  return photo.mobileSrc ? [
    { rel: "preload", as: "image", href: photo.mobileSrc, media: HERO_MOBILE_MEDIA, fetchpriority: "high" },
    { ...image, media: HERO_DESKTOP_MEDIA },
  ] : [image];
}